export function formatUptime(seconds = 0) {
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return [days ? `${days}d` : '', hours ? `${hours}h` : '', `${minutes}m`].filter(Boolean).join(' ');
}

export function formatMegabytes(megabytes?: number) {
  if (megabytes === undefined || !Number.isFinite(megabytes)) return '—';
  return megabytes >= 1024 ? `${(megabytes / 1024).toFixed(2)} GB` : `${megabytes.toFixed(megabytes >= 10 ? 1 : 2)} MB`;
}

export function formatDate(timestamp?: number) {
  return timestamp ? new Date(timestamp).toLocaleString() : '—';
}

export function fileName(path = '') {
  return path.split(/[\\/]/).pop() || 'Unknown file';
}

export function settingValue(value: unknown) {
  if (typeof value === 'boolean') return value ? 'Enabled' : 'Disabled';
  if (Array.isArray(value)) return `${value.length} configured`;
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'object') return 'Configured';
  return String(value);
}

export function titleCase(value: string) {
  return value.replace(/([A-Z])/g, ' $1').replace(/^./, (character) => character.toUpperCase());
}
